import React from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ExerciseSteps from 'modules/student/worksheets/components/ExterciseSteps';
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(248, 249, 252, .9)',
    backdropFilter: 'blur(8px)',
    paddingTop: 60,
    paddingBottom: 60,
    zIndex: 99
  },
  content: {
    overflow: 'auto',
    height: 'calc(100vh - 80px)',
    paddingRight: 16,
  },
  header: {
    '& button': {
      position: 'absolute',
      top: 10,
      right: 20,
    },
  },
}));

const PreviewModal = ({ onClose, data, module }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <IconButton onClick={onClose}>
          <CloseIcon fontSize={"large"} />
        </IconButton>
      </div>
      <Container maxWidth="md">
        <Grid container alignItems="center">
          <Grid item xs={12} sm={12}>
            <div className={classes.content}>
              <Box marginBottom={2}>
                <Typography gutterBottom color="textSecondary" variant="caption">
                  {module?.name} ~ {data.duration} minutes
                </Typography>
                <Typography gutterBottom color="textPrimary" variant="h6">
                  {data.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">{data.description}</Typography>
              </Box>
              <ExerciseSteps blocks={data.blocks} />
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default PreviewModal;
